/**
 * Horizontal Scroll Section v4 — GSAP ScrollTrigger
 * 桌面端：垂直滚动驱动水平位移（吸顶后延迟0.5vh开始 + 150vh buffer）
 * 移动端：原生横向滑动（overflow-x: auto + scroll-snap）
 */
(function () {
  'use strict';

  function initHorizontalScroll() {
    var sections = document.querySelectorAll('[data-horizontal-scroll]');
    if (sections.length === 0) return;

    sections.forEach(function (section) {
      if (section.__hsInited) return;
      section.__hsInited = true;

      var track = section.querySelector('[data-horizontal-track]');
      if (!track) return;

      function getScrollDistance() {
        var cards = track.querySelectorAll('.horizontal-scroll-card');
        if (cards.length === 0) return 0;
        var totalWidth = 0;
        cards.forEach(function (card) {
          totalWidth += card.offsetWidth;
        });
        var gaps = (cards.length - 1) * 4;  // 4px white dividers
        var trackWidth = totalWidth + gaps;
        var containerWidth = track.parentElement.offsetWidth;
        return Math.max(0, trackWidth - containerWidth);
      }

      var scrollDistance = getScrollDistance();
      if (scrollDistance <= 0) return;

      var isMobile = window.innerWidth <= 767;

      // 窗口大小变化时重新计算（桌面 + 移动端共用）
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (section.__hsCtx) {
            section.__hsCtx.revert();
            section.__hsCtx = null;
          }
          section.__hsInited = false;
          initHorizontalScroll();
        }, 250);
      });

      if (isMobile) {
        // 移动端：原生横向滑动（通过 CSS overflow-x: auto），无需 GSAP 动画
        section.style.minHeight = (window.innerHeight * 2) + 'px';
        return;
      }

      // 桌面端：滚轮驱动横向动画
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

      // 吸顶后停顿 0.5vh，给用户时间阅读标题，然后才开始横向滑动
      var titlePause = Math.round(window.innerHeight * 0.5);
      // Section 高度 = 100vh(sticky) + 150vh(buffer) + 0.5vh(titlePause) + scrollDistance
      var minH = window.innerHeight * 3 + scrollDistance;
      section.style.minHeight = minH + 'px';

      var ctx = gsap.context(function () {
        gsap.to(track, {
          x: -scrollDistance,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top+=' + titlePause + ' top',
            end: '+=' + scrollDistance,
            scrub: 0.1,
            invalidateOnRefresh: true
          }
        });
      }, section);

      section.__hsCtx = ctx;
      section.__hsScrollDist = scrollDistance;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
      }
      initHorizontalScroll();
    });
  } else {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }
    initHorizontalScroll();
  }

  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (section && section.querySelector('[data-horizontal-scroll]')) {
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          gsap.registerPlugin(ScrollTrigger);
        }
        initHorizontalScroll();
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (section) {
        var target = section.querySelector('[data-horizontal-scroll]');
        if (target && target.__hsCtx) {
          target.__hsCtx.revert();
        }
      }
    });
  }
})();
